import React, { useState } from 'react';
import { VStack, HStack, Button, Box } from '@chakra-ui/react';
import BasicSettings from './BasicsSettings';
import UrlTargeting from './UrlTargeting';
import ScrollOptions from './ScrollOptions';
import TimeBasedTargeting from './TimeBasedTargeting';
import UserTargeting from './UserTargeting';
import LocationLangTargeting from './LocationLangTargeting';
import DeviceTargeting from './DeviceTargeting';
import CustomTemplate from './CustomTemplate';

const ConfigurationEditor = ({ formik }) => {
  const [selectedConfig, setSelectedConfig] = useState('basicsetng');

  const configOptions = [
    'basicsetng',
    'urltargeting',
    'scroll',
    'timebased',
    'usertarget',
    'locationlangtarget',
    'devicetarget',
    'customtemplate',
  ];

  return (
    <form onSubmit={formik.handleSubmit}>
      <VStack spacing={6}>

        <VStack spacing={4} w="full">
        <Box w={'100%'} display={'flex'} justifyContent={'start'} gap={'15px'} >
          {configOptions.map((key) => (
            <Button
            key={key}
            onClick={() => setSelectedConfig(key)}
            variant={selectedConfig === key ? 'solid' : 'outline'}
            colorScheme="blue"
            >
              {key === 'basicsetng'
                ? 'Basic Settings'
                : key === 'urltargeting'
                ? 'URL Targeting'
                : key === 'scroll'
                ? 'Scroll Options'
                : key === 'timebased'
                ? 'Time Based Targeting'
                : key === 'usertarget'
                ? 'User Targeting'
                : key === 'locationlangtarget'
                ? 'Location & System'
                : key === 'devicetarget'
                ? 'Device Targeting'
                : 'Custom Template'}
            </Button>
          ))}

          </Box>
        {selectedConfig === 'basicsetng' && <BasicSettings formik={formik} />}
        {selectedConfig === 'urltargeting' && <UrlTargeting formik={formik} />}
        {selectedConfig === 'scroll' && <ScrollOptions formik={formik} />}
        {selectedConfig === 'timebased' && <TimeBasedTargeting formik={formik} />}
        {selectedConfig === 'usertarget' && <UserTargeting formik={formik} />}
        {selectedConfig === 'locationlangtarget' && <LocationLangTargeting formik={formik} />}
        {selectedConfig === 'devicetarget' && <DeviceTargeting formik={formik} />}
        {selectedConfig === 'customtemplate' && <CustomTemplate formik={formik} />}
        </VStack>

        {/* <Button type="submit" colorScheme="green" isLoading={formik.isSubmitting}>
          Save Campaign
        </Button> */}
      </VStack>
    </form>
  );
};

export default ConfigurationEditor;